import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "./blogfooter.scss";

function BlogFooter() {
  const { isLoggedIn, currentUserRole } = useAuth();

  const isAdmin = isLoggedIn && currentUserRole === "admin";

  return (
    <footer className="blogFooter">
      <div className="border-footer">
        <div className="logo-footer">
          <Link to="/">
            <p>
              am<span>/</span>human
            </p>
            <p>handcrafted skincare, soap & aromatherapy</p>
          </Link>
        </div>
        <div className="col">
          <div>
            <ul className="footer-links">
              <li>
                <Link to="/Recipes">RECIPES</Link>
              </li>
              <li>
                <Link to="/Shop">SHOP</Link>
              </li>
              <li>
                <Link to="/About">ABOUT</Link>
              </li>
              <li>
                <Link to="/Contact">CONTACT</Link>
              </li>
              {isAdmin && (
                <li>
                  <Link to="/Write">WRITE</Link>
                </li>
              )}
              {isLoggedIn && (
                <li>
                  <Link to="/Settings">SETTINGS</Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div className="col">
          <ul className="footer-social-links">
            <li>
              <a
                href="https://www.facebook.com/profile.php?id=61559822970669&ref=NONE_xav_ig_profile_page_web#"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="am/human on Facebook"
              >
                <img
                  className="footer-right-link-icons"
                  src="/icons-buttons/facebookV2.svg"
                  alt=""
                ></img>
              </a>
            </li>
            {/*<li>
            <a href='https://twitter.com/StudioM23' target='_blank' rel="noopener noreferrer">
              <img className="footer-right-link-icons" src="/icons-buttons/x-twitter.svg"></img>
            </a>
          </li>*/}
            <li>
              <a
                href="https://www.tiktok.com/@amhumanstudiom23?_r=1&_t=ZS-97qk8urLRCL"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="am/human on TikTok"
              >
                <img
                  className="footer-right-link-icons"
                  src="/icons-buttons/tiktok.svg"
                  alt=""
                ></img>
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/am_human_studio_m23/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="am/human on Instagram"
              >
                <img
                  className="footer-right-link-icons"
                  src="/icons-buttons/instagram.svg"
                  alt=""
                ></img>
              </a>
            </li>
            <li>
              <a
                href="mailto:mariawdesigner@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Email am/human"
              >
                <i className="emailIcon fa-regular fa-envelope" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </div>
        <div className="copyright-center-position">
          <p>© 2025 </p>
          <p>am/human. All rights reserved.</p>
          <nav className="footer-legal-links" aria-label="Legal">
            <Link to="/Privacy">Privacy Policy</Link>
            <Link to="/Terms">Terms of Sale</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}

export default BlogFooter;
